import { render } from "./AposDocsManagerDisplay.vue?vue&type=template&id=4f2e509a&scoped=true"
import script from "./AposDocsManagerDisplay.vue?vue&type=script&lang=js"
export * from "./AposDocsManagerDisplay.vue?vue&type=script&lang=js"

import "./AposDocsManagerDisplay.vue?vue&type=style&index=0&id=4f2e509a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e509a"],['__file',"piece-type/ui/apos/components/AposDocsManagerDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f2e509a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f2e509a', __exports__)) {
    api.reload('4f2e509a', __exports__)
  }
  
  module.hot.accept("./AposDocsManagerDisplay.vue?vue&type=template&id=4f2e509a&scoped=true", () => {
    api.rerender('4f2e509a', render)
  })

}


export default __exports__